/* eslint-disable sonarjs/cognitive-complexity */

import type { CosmicVariationType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { ParsedUrlQuery } from 'node:querystring'

type Props = {
  variations: CosmicVariationType[]
  query: ParsedUrlQuery
}

export const getDefaultSelectedVariation = ({
  variations,
  query,
}: Props): CosmicVariationType => {
  const defaultVariation = variations.find(
    (variation) => variation.isDefault === true,
  )

  if (query.sku) {
    return (
      variations.find((variation) => variation.sku === query.sku) ||
      defaultVariation ||
      variations[0]
    )
  }

  if (!defaultVariation) {
    return variations[0]
  }

  return defaultVariation
}
